import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SimpleReactValidator from 'simple-react-validator';
import {submitFormData} from '../../actions/registrationForms'
import { toast } from 'react-toastify';


class regEnquery extends Component {
    constructor() {
        super()
        this.state ={
            reg_firstname:'',
            reg_lastname:'',
            reg_address : '',
            reg_state : '',
            reg_city : '',
            reg_contact_number : '',
           reg_pincode : '',
           reg_store_city : '',
           reg_mail : '',
           reg_store_state : '',
           reg_store_address : '',
           exp_no :'',
           exp_yes : '',
           opening_no : '',
           opening_yes : '',
           store_yes : '',
           store_no : ''
           
        }
        this.validator = new SimpleReactValidator();
        this.handleSubmit= this.handleSubmit.bind(this)
    }
    handleSubmit = (event) => {

        event.preventDefault();
        if (this.validator.allValid()) {
            const { connection_id } = this.props
            const options = {
               connection_id:connection_id,
               name:this.state.reg_firstname,
               email:this.state.reg_mail,
               city:this.state.reg_city,
               state:this.state.reg_state,
               subject:'',
               message:''
            }
   
           this.props.submitFormData(options)
       
           
           setTimeout(function(){
                   toast.success(" Successful submitted");
                   this.props.history.goBack()
           }, 500);

        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    handleChange(event) {
      
        this.setState({ [event.target.id]: event.target.value });
    }
    render() {
        return (
            <div>
                <div className="breadcrumb-section" style={{
                    background: 'var(--theme-color)',
                    color: 'white'
                }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="page-title" style={{ display: 'block', textAlignLast: 'center' }}>
                                    <div style={{ fontSize: 15, padding: 5 }}>Home</div>
                                    <h2 style={{ fontSize: 22, color: 'white' }} >Registration</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section>
                    <div className='container enquery-form'>

                        <form onSubmit={(event) => this.handleSubmit(event)}>
                           <div className='row'>
                        
                        <div style={{padding:10}} className='col-sm-6'>
                            <label>First Name*</label>
                            <input style={{width:'100%',height:35}} type='text' onChange={(e) => this.handleChange(e)} id='reg_firstname' />
                             {this.validator.message('Name', this.state.reg_firstname, 'required|alpha_space')}

                        </div>
                        <div style={{padding:10}} className='col-sm-6'> 
                            <label>Last Name*</label>
                            <input style={{width:'100%',height:35}}type='text' onChange={(e) => this.handleChange(e)} id='reg_lastname' />
                             {this.validator.message('Last Name', this.state.reg_lastname, 'required|alpha_space')}

                        </div>
                        <div style={{padding:10}} className='col-sm-6'>
                            <label>Address*</label>
                            <input style={{width:'100%',height:35}} type='text' onChange={(e) => this.handleChange(e)} id='reg_address' />
                             {this.validator.message('Address', this.state.reg_address, 'required|alpha_space')}

                        </div>
                        <div style={{padding:10}} className='col-sm-6'>
                            <label>City*</label>
                            <input style={{width:'100%',height:35}}type='text' onChange={(e) => this.handleChange(e)} id='reg_city' />
                             {this.validator.message('City', this.state.reg_city, 'required|alpha_space')}

                        </div>
                        <div style={{padding:10}} className='col-sm-6'>
                            <label>State*</label>
                            <input style={{width:'100%',height:35}}type='text' onChange={(e) => this.handleChange(e)} id='reg_state' />
                             {this.validator.message('State', this.state.reg_state, 'required|alpha_space')}

                        </div>
                        <div style={{padding:10}} className='col-sm-6'>
                            <label>Postal Code</label>
                

                            <input style={{width:'100%',height:35}}type='number' onChange={(e) => this.handleChange(e)} id='reg_pincode' min='100000' oninput="validity.valid||(value='');" />
                             {this.validator.message('Postal Code', this.state.reg_pincode, 'required|number')}

                        </div>
                        <div style={{padding:10}} className='col-sm-6'>
                            <label>Contact Number*</label>

                            <input style={{width:'100%',height:35}}type='number' min='1000000000' oninput="validity.valid||(value='');" onChange={(e) => this.handleChange(e)} id='reg_contact_number' />
                             {this.validator.message('Contact Number', this.state.reg_contact_number, 'required|number')}

                        </div>
                        <div style={{padding:10}} className='col-sm-6'>
                            <label>Email*</label>
                            <input style={{width:'100%',height:35}}type='text' onChange={(e) => this.handleChange(e)} id='reg_mail' />
                             {this.validator.message('Email', this.state.reg_mail, 'required|email')}

                        </div>
                        <div style={{padding:10}} className='col-sm-6'>
                            <label>Store Address*</label>
                            <input style={{width:'100%',height:35}}type='text' onChange={(e) => this.handleChange(e)} id='reg_store_address' />
                             {this.validator.message('Store Address', this.state.reg_store_address, 'required|alpha_space')}

                        </div>
                        <div style={{padding:10}} className='col-sm-6'>
                            <label>City*</label>
                            <input style={{width:'100%',height:35}}type='text' onChange={(e) => this.handleChange(e)} id='reg_store_city' />
                             {this.validator.message('Email', this.state.reg_store_city, 'required|alpha_space')}

                        </div>
                        <div style={{padding:10}} className='col-sm-6'>
                            <label>State*</label>
                            <input style={{width:'100%',height:35}}type='text' onChange={(e) => this.handleChange(e)} id='reg_store_state' />
                             {this.validator.message('Store State', this.state.reg_store_state, 'required|alpha_space')}

                        </div>
                        
                        </div>
                        <div className='row'>
                                <div className='col-md-6' style={{padding:10}}>
                            <div  className='col-sm-12'>
                                <label>Have you got any experience in the cycling industry?*</label><br/>
                                <input style={{width:'4%',height:12 ,marginLeft:10}} type='radio' onChange={(e) => this.handleChange(e)} id='exp_yes' value='Yes' />Yes
                                <input style={{width:'4%',height:12 ,marginLeft:10}} type='radio' onChange={(e) => this.handleChange(e)} id='exp_no' value='No' />No
                               <div style={{paddingTop:10}}> {this.validator.message('Experience', this.state.exp_yes || this.state.exp_no, 'required')}</div>

                            </div>
                            <div  className='col-sm-12'>
                                <label>Operating or own a bike store currently?*</label><br/>
                                <input style={{width:'4%',height:12 ,marginLeft:10}} type='radio' onChange={(e) => this.handleChange(e)} id='store_yes' value='Yes' />Yes
                                <input style={{width:'4%',height:12 ,marginLeft:10}} type='radio' onChange={(e) => this.handleChange(e)} id='store_no' value='No' />No
                               <div style={{paddingTop:10}}> {this.validator.message('Current Store', this.state.store_yes || this.state.store_no, 'required')} </div>


                            </div>
                            <div  className='col-sm-12'>
                                <label>Are you interested in opening a Giant exclusive brand store in your city?*</label><br/>
                                <input style={{width:'4%',height:12 ,marginLeft:10}} type='radio' onChange={(e) => this.handleChange(e)} id='opening_yes' value='Yes' />Yes
                                <input style={{width:'4%',height:12 ,marginLeft:10}} type='radio' onChange={(e) => this.handleChange(e)} id='opening_no' value='No' />No
                               <div style={{paddingTop:10}}> {this.validator.message('Opeing Shop City', this.state.opening_yes || this.state.opening_no, 'required')}</div>
 
                            </div>
                            </div></div>
                                <div className='col-md-12'><div style={{padding:10}}>
                                    
                                <button className='btn btn-solid'>SUBMIT</button></div></div>
                            
                            
                            
                            

                        </form>
                    </div>
                </section>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    connection_id: state.tenant.connection_id,
    isAuth: state.user.isAuth,
    error: state.user.error,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { submitFormData },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(regEnquery))